window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    // window.$ = window.jQuery = require('jquery');
    global.$ = global.jQuery = require('jquery');
    window.toastr = require('toastr');
    window.moment = require('moment');
    window.Swal = require('sweetalert2');
    window.JSZip = require('jszip');
    
    require('bootstrap');
    window.bsCustomFileInput = require('bs-custom-file-input');
    require('admin-lte');
    require('datatables.net/js/jquery.dataTables');
    require('datatables.net-bs4/js/dataTables.bootstrap4');
    require('datatables.net-responsive-bs4/js/responsive.bootstrap4');
    require('datatables.net-buttons-bs4/js/buttons.bootstrap4');
    require('datatables.net-buttons/js/buttons.html5');
    require('datatables.net-buttons/js/buttons.print');

    require('overlayscrollbars/js/OverlayScrollbars');
    require('jquery-validation/dist/jquery.validate');
    require('jquery-validation/dist/localization/messages_th');
    require('daterangepicker/daterangepicker');
    // require('select2/dist/js/select2');
    require('admin-lte/plugins/select2/js/select2.full');
    require('pace-js/pace');
   
    
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
